import GET_USER_ROLES from '@/graphql/queries/getUserRoles.gql'
import camelcaseKeys from 'camelcase-keys'
import { useDrf } from '@/services/featureFlags'
import { api } from '@/services/api'

export default {
    data () {
        return {
            rolesLoading: false,
            rolesLoaded: false,
            roles: null,
        }
    },
    apollo: {
        roles: {
            query: GET_USER_ROLES,
            variables() {
                return {
                    userId: this.userId,
                }
            },
            skip() {
                // we want to run this if skipFiltered is false
                return !this.userId || useDrf('getUserRoles')
            },
            update({ roles }) {
                // TODO: need to add code to skip this stuff if user doesn't have
                this.rolesLoaded = true
                return camelcaseKeys(roles, {deep: true})
            },
            watchLoading (isLoading, countModifier) {
                this.rolesLoading = isLoading
            },
            error(error, vm, key, type, options) {
                // for now, we just load it up with random data so we can see something
                this.error = error.message
            }
        },
    },
    mounted() {
        if (useDrf('getUserRoles') && this.userId) {
            this.fetchRolesDrf()
        }
    },
    methods: {
        async fetchRolesDrf() {
            this.rolesLoading = true
            try {
                // §H.1.4b — only staff callers send ?user_id. The BE
                // (UserRoleViewset) silently drops it for non-staff
                // anyway; the FE skips it as defense-in-depth so a
                // future regression on the BE filter cannot turn a
                // non-staff caller into a role-enumeration vector.
                const isStaff = this.$auth?.user?.()?.staff
                const params = isStaff ? { userId: this.userId } : {}
                this.roles = await api.get('web.userrole/', params) || []
                this.rolesLoaded = true
            } catch (e) {
                this.error = e?.message
            } finally {
                this.rolesLoading = false
            }
        },
    },
    computed: {
        hasSurveyorRole() {
            return this.roles && this.roles.length > 0 && this.roles.some(r => r.webQpaUserGroups[0].role.toUpperCase() === 'SU') || null
        },
        hasPracticeManagerRole() {
            return this.roles && this.roles.length > 0 && this.roles.some(r => r.webQpaUserGroups[0].role.toUpperCase() === 'PM') || null
        },
        canViewResources() {
            return this.hasPracticeManagerRole || this.isAdmin || this.isSurveyor
        }
    },
    watch: {
        userId() {
            this.rolesLoading = false
            if (useDrf('getUserRoles')) {
                this.fetchRolesDrf()
            } else {
                this.$apollo.queries.roles.refetch()
            }
        }
    }
}
